import React from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import { ThumbUp } from "components/icons/generated";
import SearchInput from "components/SearchInput";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import LinkButton from "ds/components/Button/LinkButton";
import ButtonIcon from "ds/components/ButtonIcon";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import MobileView from "components/Mobile/MobileView";
import DesktopView from "components/Mobile/DesktopView";
import useCanCreateStack from "shared/Stack/access/useCanCreateStack";
import Tooltip from "ds/components/Tooltip";

import { FILTERS_ORDER_SETTINGS_KEY, STACK_LIST_NEW_FEEDBACK_ID } from "./constants";
import styles from "./styles.module.css";

type StacksPageLayoutProps = {
  children: React.ReactNode;
  searchCallback?: () => void;
};

const StacksPageLayout = ({ children, searchCallback }: StacksPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const canCreateStack = useCanCreateStack();

  useTitle(`Stacks · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel className={styles.header}>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Stacks</ViewHeaderTitle>
          <MobileView>
            <Tooltip
              active={!!canCreateStack.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  to="/new/stack"
                  variant="primary"
                  disabled={!canCreateStack.result}
                  analyticsPage={AnalyticsPageStack.StacksList}
                  analyticsTitle="Create Stack"
                >
                  Create stack
                </LinkButton>
              )}
            >
              {canCreateStack.message}
            </Tooltip>
          </MobileView>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper direction="row">
          <SearchInput
            callback={searchCallback}
            placeholder="Search by name, ID or labels"
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />
          <FiltersMobileTriggerButton />
          <DesktopView>
            <DocumentationIconButton
              href={getDocsUrl("/concepts/stack")}
              tooltipText="Go to stacks documentation"
            />

            <ButtonIcon
              size="medium"
              variant="secondary"
              id={STACK_LIST_NEW_FEEDBACK_ID}
              icon={ThumbUp}
            >
              Leave feedback
            </ButtonIcon>

            <Tooltip
              active={!!canCreateStack.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  to="/new/stack"
                  variant="primary"
                  disabled={!canCreateStack.result}
                  analyticsPage={AnalyticsPageStack.StacksList}
                  analyticsTitle="Create Stack"
                >
                  Create stack
                </LinkButton>
              )}
            >
              {canCreateStack.message}
            </Tooltip>
          </DesktopView>
        </ViewHeaderWrapper>
      </ViewHeader>
      {children}
    </>
  );
};

export default StacksPageLayout;
